import { useDiscountWizardStateContext } from '../state';
import { RequirementsStepActions } from '../state/requirements';
import { RewardsStepActions } from '../state/rewards';

import type { FilterResource, FilterResourceType } from './filter';
import type { FilterType } from 'src/app/components/lib/wizard/filters';

type UpdateFilterArg = {
  resources: FilterResource[];
  resourceType: FilterResourceType;
  selectionType: FilterType;
};

export function useConditionalFilterModalParameters(requirement: number | 'reward') {
  const { requirementsStepState, requirementsStepDispatch, rewardsStepState, rewardsStepDispatch } =
    useDiscountWizardStateContext();
  if (requirement === 'reward') {
    return {
      filters: rewardsStepState.condition.filters,
      noun: 'reward',
      onClose: () =>
        rewardsStepDispatch({
          type: RewardsStepActions.SET_ACTIVE_FILTER,
          payload: undefined,
        }),
      titleFragment: 'reward products',
      updateFilter: ({ resourceType, resources, selectionType }: UpdateFilterArg) => {
        rewardsStepDispatch({
          type: RewardsStepActions.SET_REWARD_PRODUCTS_FILTER,
          payload: {
            resources,
            resourceType,
            selectionType,
          },
        });
      },
    };
  }
  return {
    filters: requirementsStepState[requirement].filters,
    noun: 'discount',
    onClose: () =>
      requirementsStepDispatch({
        type: RequirementsStepActions.SET_ACTIVE_FILTER,
        payload: {
          filter: undefined,
          requirement: undefined,
        },
      }),
    titleFragment: 'products in discount',
    updateFilter: ({ resourceType, resources, selectionType }: UpdateFilterArg) => {
      requirementsStepDispatch({
        type: RequirementsStepActions.SET_REQUIREMENT_FILTER,
        payload: {
          index: requirement,
          value: {
            resourceType,
            resources,
            selectionType,
          },
        },
      });
    },
  };
}
